import "./style.css";
import MobileAbout from "./MobileAbout";

//about page
function About(props: any) {
  const { isDesktop, aboutUsTitle, aboutUsText, aboutImage } = props;
  return (
    <div className="about" id="about">
      {isDesktop ? (
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1 }}>
            <div className="title-container">
              <h1>RÓLUNK</h1>
              <h2>{aboutUsTitle}</h2>
            </div>
            <div className="big-wrapper">
              <div className="text-container">
                <p>
                  {aboutUsText?.map((data: any, index: number) => (
                    <span key={`aboutUsText-${index}`}>
                      {data.aboutUsParagraph}
                      {index + 1 < aboutUsText.length ? (
                        <>
                          <br />
                          <br />
                        </>
                      ) : null}
                    </span>
                  ))}
                </p>
              </div>
            </div>
          </div>
          <div className="video-container" style={{ flex: 1 }}>
            <img alt="" className="about-me-img" src={aboutImage}></img>
          </div>
        </div>
      ) : (
        <MobileAbout
          aboutImage={aboutImage}
          aboutUsTitle={aboutUsTitle}
          aboutUsText={aboutUsText}
        ></MobileAbout>
      )}
    </div>
  );
}

export default About;
